import { render, staticRenderFns } from "./ManageClient.vue?vue&type=template&id=fa82a7da&"
import script from "./ManageClient.vue?vue&type=script&lang=js&"
export * from "./ManageClient.vue?vue&type=script&lang=js&"
import style0 from "./ManageClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports